
import CarParkApi from './src/CarParkApi'
import BaseDataApi from './src/BaseDataApi'
import LedApi from './src/LedApi'
import AlarmApi from './src/AlarmApi'
import ExecutTaskApi  from './src/ExecutTask'
import UniformConfigApi from './src/UniformConfigApi'
import PeopleApi from './src/PeopleApi'
import FlowApi from './src/FlowApi'
import FileApi from './src/FileManagementResources'
import WifiApi from './src/WifiApi'

let apis = {
    CarParkApi,
    BaseDataApi,
    LedApi,
    AlarmApi,
    ExecutTaskApi,
    UniformConfigApi,
    PeopleApi,
    FlowApi,
    FileApi,
    WifiApi
};

export default apis;
